import { spiritoryWebApi } from '@/lib/axios/SpiritoryWebApi/spiritoryWebApi';
import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';
import { BlogPost } from '@/types/Blog';
import { getValidLocale } from '@/utilites/language/language.utils';
import type { BlogQueryName } from '@/utilites/strapi-proxy-queries';

export default async function getBlogPosts(
  name: BlogQueryName,
  locale: string = 'en',
  search?: string
): Promise<BlogPost[]> {
  const validLocale = getValidLocale(locale);
  const searchParam = search ? `&search=${encodeURIComponent(search.trim())}` : '';
  const finalURL = `/blog?name=${name}&locale=${validLocale}${searchParam}`;
  const {
    data: { data },
  } = await spiritoryWebApi.get<BaseApiResponse<BlogPost[]>>(finalURL as SpiritoryWebEndpoints);
  return data;
}
